export enum FileTypes{
  IMAGE ="image",
  DOC_EXCEL ="excel",
  DOC_WORD ='word'
}
